module.exports = __webpack_public_path__ + "img/3_194.35fd6da8.png";